import { useEffect, useRef } from 'react';

interface UseAutoValidateHtsParams {
  active: boolean;
  validate: () => void;
}

// Runs the HTS validation flow (like clicking "Validate HTS") once, as soon as
// `active` becomes true. Fires at most once per mount.
export const useAutoValidateHts = ({
  active,
  validate,
}: UseAutoValidateHtsParams): void => {
  const validatedRef = useRef(false);

  useEffect(() => {
    if (validatedRef.current || !active) return;
    validatedRef.current = true;
    void validate();
  }, [active, validate]);
};
